import axios from 'axios';
import store from '../store/store';
import { logout } from '../store/slices/authSlice';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const BASE_URL = API_URL.replace(/\/api$/, '');

/**
 * Resolve any vehicle/driver image path to a full URL.
 * Handles three formats stored in the DB:
 *  1. Full URL already:          "http://localhost:8000/storage/fleet_photos/x.png"
 *  2. Path with /storage/ prefix: "/storage/fleet_photos/x.png"
 *  3. Bare storage-relative path: "fleet_photos/x.png" or "driver_documents/.../x.png"
 */
export const getStorageUrl = (path) => {
  if (!path) return null;
  // Already a full URL
  if (/^https?:\/\//.test(path)) return path;
  // Has /storage/ prefix — just prepend the base
  if (path.startsWith('/storage/')) return `${BASE_URL}${path}`;
  // Bare path — prepend base + /storage/
  return `${BASE_URL}/storage/${path}`;
};

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - clear all auth state (Redux + localStorage) and redirect
      store.dispatch(logout());
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
